/**
 * @generated SignedSource<<1b42c03b90e0acfededa44d4b676cad5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateTabbedSectionRelayFragment$data = {
  readonly howToUseThisTemplate: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"templateGuideRelayFragment">;
  }> | null | undefined;
  readonly templateBenefits: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"templateBenefitsRelayFragment">;
  }> | null | undefined;
  readonly templateOverview: ReadonlyArray<{
    readonly overviewDescription: string | null | undefined;
    readonly overviewTitle: string | null | undefined;
  }> | null | undefined;
  readonly templateProductRationale: ReadonlyArray<{
    readonly rationaleTitle: string | null | undefined;
    readonly templateProductRationaleDescription: string | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "templateTabbedSectionRelayFragment";
};
export type templateTabbedSectionRelayFragment$key = {
  readonly " $data"?: templateTabbedSectionRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateTabbedSectionRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateTabbedSectionRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateOverview",
      "kind": "LinkedField",
      "name": "templateOverview",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "overviewTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "overviewDescription",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateBenefitContainer",
      "kind": "LinkedField",
      "name": "templateBenefits",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "templateBenefitsRelayFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateGuide",
      "kind": "LinkedField",
      "name": "howToUseThisTemplate",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "templateGuideRelayFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateProductRationale",
      "kind": "LinkedField",
      "name": "templateProductRationale",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rationaleTitle",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "templateProductRationaleDescription",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplate",
  "abstractKey": null
};

(node as any).hash = "b2893f87aa786b55bda7e5cc59a7c618";

export default node;
